import { logInfo } from "@lib/logger";

export function mergeSvg(
  parent: string,
  child: string,
  childOffsetX: number,
  childOffsetY: number,
): string | undefined {
  const parser = new DOMParser();
  const doc1 = parser.parseFromString(parent, "image/svg+xml");
  const doc2 = parser.parseFromString(child, "image/svg+xml");

  const svgEl1 = doc1.documentElement;
  const svgEl2 = doc2.documentElement;
  const vb1str = svgEl1.getAttribute("viewBox");
  const vb2str = svgEl2.getAttribute("viewBox");
  if (!vb1str || !vb2str) {
    logInfo("Missing viewBox", { vb1str, vb2str });
    return;
  }

  const vb1 = vb1str.split(" ").map(Number);
  const vb2 = vb2str.split(" ").map(Number);

  // Set combined SVG's viewBox to the first SVG's viewBox
  const [x1, y1, w1, h1] = vb1;
  const [x2, y2, w2, h2] = vb2;

  const combinedSVG = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "svg",
  );
  combinedSVG.setAttribute("viewBox", `${x1} ${y1} ${w1} ${h1}`);
  combinedSVG.setAttribute("xmlns", "http://www.w3.org/2000/svg");

  // First SVG: no transform
  const g1 = document.createElementNS("http://www.w3.org/2000/svg", "g");
  g1.innerHTML = svgEl1.innerHTML;

  // Second SVG: scale and translate to fit into first SVG's viewBox
  const g2 = document.createElementNS("http://www.w3.org/2000/svg", "g");
  g2.innerHTML = svgEl2.innerHTML;

  // Calculate scale and translation
  const scaleX = w1 / w2;
  const scaleY = h1 / h2;
  const scale = Math.min(scaleX, scaleY) * 0.5;

  // Center the second SVG in the first SVG's viewBox
  const centerX = x1 + w1 / 2;
  const centerY = y1 + h1 / 2;
  const childCenterX = x2 + w2 / 2;
  const childCenterY = y2 + h2 / 2;

  const translateX = centerX - childCenterX * scale + childOffsetX;
  const translateY = centerY - childCenterY * scale + childOffsetY;

  g2.setAttribute(
    "transform",
    `translate(${translateX},${translateY}) scale(${scale})`,
  );

  combinedSVG.appendChild(g1);
  combinedSVG.appendChild(g2);

  return new XMLSerializer().serializeToString(combinedSVG);
}
